import React from 'react'
import { Space, Tooltip } from 'antd'
import { IconButton } from '../../../../shared/components/buttons/icon-button/IconButton'
import { IconSpy } from '../../../../shared/components/icons/IconSpy'
import { IconSpyOff } from '../../../../shared/components/icons/IconSpyOff'
import { IconEye } from '../../../../shared/components/icons/IconEye'
import { IconEyeOff } from '../../../../shared/components/icons/IconEyeOff'
import {
  AdvertiserReportItem,
  PostAdvertiserReportsSiteSettingsApiArg,
  usePostAdvertiserReportsDecloakSettingsMutation,
  usePostAdvertiserReportsSiteSettingsMutation,
} from '../../../../app/api'
import { useTranslation } from 'react-i18next'

interface ActionsCellProps {
  is_hide: boolean
  is_decloak: boolean
  is_affiliate: boolean
  advertiser: string
  progress_status: AdvertiserReportItem['progress_status']
  project: string
  allowDecloak: boolean
}

export const ActionsCell = ({
  is_hide,
  is_decloak,
  is_affiliate,
  advertiser: domain,
  progress_status: status,
  project,
  allowDecloak,
}: ActionsCellProps) => {
  const { t } = useTranslation()
  const [editDecloakSetting] = usePostAdvertiserReportsDecloakSettingsMutation()
  const [editSiteSetting] = usePostAdvertiserReportsSiteSettingsMutation()

  return (
    <Space>
      {allowDecloak && (
        <Tooltip placement={'topRight'} title={t('buttons.other.enableUncloakingTooltip')}>
          <div>
            <IconButton
              size='lg'
              onClick={() => {
                if (!project) return
                editDecloakSetting({
                  body: {
                    project_id: +project,
                    domain,
                    is_decloak: is_decloak ? 0 : 1,
                  },
                })
              }}
            >
              {is_decloak ? <IconSpyOff /> : <IconSpy />}
            </IconButton>
          </div>
        </Tooltip>
      )}
      <Tooltip title={is_hide ? t('buttons.unhide') : t('buttons.hide')}>
        <div>
          <IconButton
            size='lg'
            onClick={() => {
              if (!project) return
              editSiteSetting({
                body: {
                  is_affiliate: is_affiliate ? 1 : 0,
                  domain,
                  status: status as PostAdvertiserReportsSiteSettingsApiArg['body']['status'],
                  is_hide: !is_hide ? 1 : 0,
                  project_id: +project,
                },
              })
            }}
          >
            {is_hide ? <IconEye color='#A059FF' /> : <IconEyeOff color='#A059FF' />}
          </IconButton>
        </div>
      </Tooltip>
    </Space>
  )
}
